import { Col } from "react-bootstrap";
import preLoader from '../assets/loading.svg';

const ImageCard = ({photo: {farm, server, id, secret, title}}) => {
    const imgURL = `https://farm${farm}.staticflickr.com/${server}/${id}_${secret}_m.jpg`;

    const handleOnLoad = evt => {
        evt.target.src = evt.target.dataset.src;
        evt.target.onLoad = null;
    }

    const handleOnError = evt => {
        evt.target.src = 'https://via.placeholder.com/220x200';
        evt.target.onError = null;
    }

    return (
        <Col xs={6} md={3} className="flex-grow-1 p-2">
            <img 
                src={preLoader} 
                data-src={imgURL} alt={title} width="220" height="165" loading="lazy" 
                onLoad={handleOnLoad}
                onError={handleOnError}
                className="w-100"
            />
        </Col>
    )
}

export default ImageCard;